<template>
  <v-container fluid>
    <v-card-actions>
      <v-btn-toggle
        v-model="toggle" 
        mandatory
        group
        color="primary"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn 
              text 
              icon
              v-on="on"
              @click="showActivePositions = 1"
            >
              <v-icon>select_all</v-icon>
            </v-btn>
          </template>
          <span>Active Positions</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn 
              text
              icon 
              v-on="on"
              @click="showActivePositions = 0"
            >
              <v-icon>delete_outline</v-icon>
            </v-btn>
          </template>
          <span>Trash</span>
        </v-tooltip>
      </v-btn-toggle>
      <v-divider
        class="mr-5"
        vertical
      />
      <div v-show="showActivePositions">
        <setup-positions-groups-dialog-create
          v-if="$hasPermissionTo(['create position groups'])"
          @created="loadPositionGroups"
        />
      </div>
    </v-card-actions>

    <v-row>
      <v-col
        v-for="positionGroup in filteredPositionGroups"
        :key="positionGroup.id"
        cols="12"
        md="4"
        xl="4"
      >
        <v-hover>
          <v-card
            slot-scope="{ hover }"
            :class="[`elevation-${hover ? 12 : 2}`, 'pa-1']"
          >
            <v-list one-line>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium text-capitalize px-0">
                    {{ positionGroup.name }}
                  </v-list-item-title>

                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="12">
                          <span class="font-weight-bold">Position Categories:</span>
                        </v-col>
                      </v-row>

                      <span v-if="positionGroup.position_categories.length>0">
                        <v-chip
                          v-for="positionCategory in positionGroup.position_categories"
                          :key="positionCategory.id"
                          dense
                          class="text--primary mx-1"
                        >
                          {{ positionCategory.name }}
                        </v-chip>
                      </span>
                      <span v-else>
                        No Data Available
                      </span>
                    </v-col>

                    <v-col cols="12">
                      <v-row>
                        <v-col cols="12">
                          <span class="font-weight-bold">Leave Entitlements:</span>
                        </v-col>
                      </v-row>

                      <span v-if="positionGroup.position_group_leave_entitlement_settings.length>0">
                        <v-chip
                          v-for="leave_entitlement_setting in positionGroup.position_group_leave_entitlement_settings"
                          :key="leave_entitlement_setting.id"
                          dense
                          class="text--primary mx-1"
                        >
                          {{ leave_entitlement_setting.leave_entitlement_setting.name }}
                        </v-chip>
                      </span>
                      <span v-else>
                        No Data Available
                      </span>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider light />
            <v-card-actions v-if="showActivePositions">
              <v-spacer />
              
              <setup-positions-groups-dialog-edit
                v-if="$hasPermissionTo(['update position groups'])"
                :position-group="positionGroup"
                @updated="loadPositionGroups"
              />
              <setup-positions-groups-dialog-delete
                v-if="$hasPermissionTo(['delete position groups'])"
                :position-group="positionGroup"
                @deleted="refreshData"
              /> 
            </v-card-actions>
            <v-card-actions v-else>
              <v-spacer />
              <setup-positions-groups-dialog-restore
                v-if="$hasPermissionTo(['delete position groups'])"
                :position-group="positionGroup"
                @restored="refreshData"
              />
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <v-row
      v-show="positionGroups.length === 0 && loading === false"
      justify="center"
    >
      <v-col
        class="text-center"
        cols="12"
      >
        <div class="headline">
          <span class="blue-grey--text">No Data Available</span>
        </div>
      </v-col>   
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupPositionsGroupsDialogCreate: () => import('@/components/setup/positions/groups/DialogCreate'),
      SetupPositionsGroupsDialogEdit: () => import('@/components/setup/positions/groups/DialogEdit'),
      SetupPositionsGroupsDialogDelete: () => import('@/components/setup/positions/groups/DialogDelete'),
      SetupPositionsGroupsDialogRestore: () => import('@/components/setup/positions/groups/DialogRestore'),
    },

    data () {
      return {
        loading: true,
        showActivePositions: 1,
        toggle: 0,
        positionGroups: [],
        trashedPositionGroups: [],
      }
    },

    computed: {
      filteredPositionGroups () {
        return this.showActivePositions ? this.positionGroups : this.trashedPositionGroups
      },
    },

    watch: {
      showActivePositions: {
        immediate: true,
        handler (value) {
          if (value) {
            if (this.positionGroups.length <= 0) this.loadPositionGroups()
          } else {
            if (this.trashedPositionGroups.length <= 0) this.loadTrashedPositionGroups()
          }
        },
      },
    },

    created () {
      this.loadPositionGroups()
    },

    methods: {
      refreshData () {
        this.loadPositionGroups()
        this.loadTrashedPositionGroups()
      },

      loadPositionGroups () {
        this.$api.positionGroups().list()
          .then(res => {
            this.positionGroups = res.data

            this.loading = false
          })
      },

      loadTrashedPositionGroups () {
        this.$api.positionGroups().listTrashed()
          .then(res => {
            this.trashedPositionGroups = res.data
            this.loading = false
          })
      },
    },
  }
</script>
